// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"436":"ce7efdee","548":"b105250c","629":"7637d10a","720":"90aa291b","945":"350be7f2"}[chunkId] + ".chunk.js";
};